import { T, getDateTimeFormat } from 'i18n/utils'
import classNames from 'classnames'

import styles from './styles.module.scss'

const DateTime = ({ fromDate, toDate, promptAutoRenew, autoRenew, setAutoRenewPending, onChange }) => (
    <div className={classNames(styles.detail, styles.time, 'col')}>
        <p>
            <T>label.parking.start</T>
            {` ${fromDate.format(getDateTimeFormat())}`}
        </p>
        <p>
            <T>label.parking.end</T>
            {` ${toDate.format(getDateTimeFormat())}`}
        </p>
        {promptAutoRenew && (
            <div className="form-check">
                <label className="form-check-label">
                    {setAutoRenewPending === true ? (
                        <div className="spinner" />
                    ) : (
                        <input type="checkbox" className="form-check-input" checked={autoRenew} onChange={onChange} />
                    )}
                    &nbsp; <T>basket.auto.renew.label</T>
                </label>
            </div>
        )}
    </div>
)

export default DateTime
